import Formsy from 'formsy-react';
import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { Dimmer, Loader } from 'semantic-ui-react';
import InvoiceSection from '../../components/SellerSignup/InvoiceSection';
import PlansSection from '../../components/SellerSignup/PlansSection';
import { getAllSubscribableCategories, getSubscribableCategories } from '../../services/categories';
import { addSubscription, getPaymentMethods } from '../../services/Seller';
import { getPaymentIntent } from '../../services/stripe';
import { getActiveSubscriptions, getPlan, getPlans } from '../../services/subscription';
import { loadStripe } from '@stripe/stripe-js';
import SignupWizard from '../../components/SellerSignup/SignupWizard'
import Config from 'Config'
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import './SubscriptionContainer.less'
import SellerStripeForm from '../../components/SellerSignup/SellerStripeForm';
import '../../components/SellerSignup/Tabs/Confirmation.less';
import confirmImg from '../../assets/images/newui/sellersignup/confirmation.svg'
import tickImg from '../../assets/images/newui/sellersignup/tick-rounded.svg'
import next from '../../assets/images/newui/sellersignup/next-btn.svg'
import ErrorBox from '../../components/SellerSignup/ErrorBox';
import PaymentCard from '../../components/SellerSignup/PaymentCard';

const SubscriptionContainer = ({ history, match }) => {
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setCategory] = useState({});
    const [paymentMethods, setPaymentMethods] = useState(null);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState({});
    const [plans, setPlans] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState();
    const [isLoading, setLoading] = useState(false);
    const [stripe, setStripe] = useState();
    const [card, setCard] = useState();
    const [error, setError] = useState('');
    const [activeIndex, setActiveIndex] = useState(0);
    const [promo, setPromo] = useState();
    const [isCardFormVisible, setCardFormVisibility] = useState(true);
    const [hasDefaultPlan, setHasDefaultPlan] = useState(false);
    const location = useLocation();
    const getCategories = match.params.planID || location.search.startsWith('?categoryId=') ? getAllSubscribableCategories : getSubscribableCategories;

    useEffect(() => {
        getCategories().then(res => {
            setCategories(res.data);

            if (location.search.startsWith('?categoryId=')) {
                const categoryID = location.search.replace('?categoryId=', '');
                const category = res.data.find(c => c.categoryID == categoryID);
                if (category) {
                    onCategoryChange(category);
                    setActiveIndex(1);
                }
                else {
                    history.push(location.pathname)
                }
            } else if (match.params.planID) {
                setActiveIndex(2)
                showLoader()
                getPlan(match.params.planID).then(({ data }) => {
                    const selectedCategory = res.data.find(c => c.categoryID == (data || {}).categoryID);
                    if (data && selectedCategory) {
                        setSelectedPlan({ plan: { ...data, planName: data.name, planType: data.type }, features: data.features });
                        setCategory(selectedCategory);
                        setHasDefaultPlan(true);
                        hideLoader();
                    } else {
                        history.push('/signin');
                    }
                })
            }
        })
        getPaymentMethods().then(res => {
            if (res.data) {
                setPaymentMethods(res.data)
                setSelectedPaymentMethod(res.data[0])
                setCardFormVisibility(false)
            }
            else {
                setPaymentMethods([])
            }
        })

        loadStripe(Config.stripe.key).then(res => setStripe(res));
    }, [])

    const onSubmit = async () => {
        try {
            showLoader();
            let pymtMethod = selectedPaymentMethod;
            if (isCardFormVisible) {
                if (!card) {
                    setError('Invalid card details.')
                    return;
                }
                // payment method creation
                const paymentMethodRes = await stripe.createPaymentMethod({
                    type: 'card',
                    card
                });

                if (paymentMethodRes.error) {
                    setError(paymentMethodRes.error.message)
                    return;
                }
                pymtMethod = { ...paymentMethodRes.paymentMethod, customer: selectedPaymentMethod.customer };
            }
            const paymentRes = await getPaymentIntent({ planID: selectedPlan.plan.planID, promo, customerID: pymtMethod.customer }, true)
            const paymentConfirmation = await stripe.confirmCardPayment(paymentRes.data.intent.client_secret, {
                payment_method: pymtMethod.id,
                setup_future_usage: 'off_session'
            });

            if (paymentConfirmation.error) {
                setError(paymentConfirmation.error.message);
            } else {
                const sellerRes = await addSubscription({
                    paymentIntentID: paymentRes.data.intent.id,
                    isNewPaymentMethod: isCardFormVisible,
                    planID: selectedPlan.plan.planID
                });
                if (sellerRes.resStatus == 200) {
                    setActiveIndex(3);
                    const { data } = await getActiveSubscriptions();
                    setTimeout(() => {
                        window.location.href = '/active-subscription'
                    }, 2000)
                } else {
                    setError('Unable to complete subscription.')
                }
            }
        } catch (err) {
            console.log(err);
        } finally {
            hideLoader();
        }
    }

    const onCategoryChange = (cat) => {
        setCategory(cat)
        getPlans(cat.categoryID).then(res => {
            setPlans(res.data);
            setSelectedPlan();
            setActiveIndex(1)
        })
    }

    const onPlanSelect = (plan) => {
        setSelectedPlan(plan)
        setActiveIndex(2);
    }

    const showLoader = () => {
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        });
        document.body.style.overflowY = 'hidden'
        setLoading(true)
    }

    const hideLoader = () => {
        document.body.style.overflowY = 'unset'
        setLoading(false);
    }

    const onCardFormToggle = (e, value) => {
        e.preventDefault();
        setCardFormVisibility(value);
    }

    const moveBack = () => {
        if (hasDefaultPlan || location.search.startsWith('?categoryId=')) {
            history.goBack()
        } else {
            setActiveIndex(activeIndex - 1)
        }
    }

    return stripe ? <div className='subscription-container-boundary'>
        {isLoading ? <Dimmer active>
            <Loader indeterminate size='massive' />
        </Dimmer> : ''}
        {activeIndex != 3 ? <SignupWizard
            activeTabIndex={activeIndex}
            moveBack={moveBack} /> : ''}
        <div className='subscription-container'>
            <div className={`subscription-container-form seller-subscription-tab${activeIndex != 0 ? ' hidden' : ''}`}>
                <div className='subscription-container-form-header'> Select Category</div>
                <div className='subscription-container-form-sub-header'> A Full-Digital Lead Platform To Manage And Grow Your Business</div>
                {categories.map(cat =>
                    <div className='subscription-container-category' onClick={() => onCategoryChange(cat)}>
                        {selectedCategory.categoryID == cat.categoryID ? <img className='tick-img' src={tickImg} /> : ''}
                        <img className='subscription-container-category-img' src={cat.detailImageNarrow ? cat.detailImageNarrow.URL : ''} />
                        <div className='subscription-container-category-name'>{cat.name}</div>
                    </div>
                )}
            </div>
            <div className={`subscription-container-plans seller-subscription-tab${activeIndex != 1 ? ' hidden' : ''}`}>
                <div className='choose-plan-heading'>A Full-Digital Lead Platform To Manage And Grow Your Business</div>
                <div className='choose-plan-sub-heading'>Stop Getting Tired Of Paying For Leads That Don't Convert</div>
                {plans.length ? <PlansSection
                    plans={plans}
                    onPlanSelect={onPlanSelect}
                    selectedCategory={selectedCategory}
                /> : ''}
            </div>
            <div className={`subscription-container-invoice seller-subscription-tab${activeIndex != 2 ? ' hidden' : ''}`}>
                <div className='subscription-container-header'>{selectedCategory ? selectedCategory.checkoutHeading || "Get New Customers Delivered Straight to Your Inbox Each Week!" : ''}</div>
                {error ? <div className='subscription-container-error'><ErrorBox message={error} /></div> : ''}
                <Formsy onValidSubmit={onSubmit}>
                    <div className='subscription-container-card'>
                        {paymentMethods ? isCardFormVisible ? <div className='subscription-container-card-new'>
                            <Elements stripe={stripe}>
                                <ElementsConsumer>
                                    {({ stripe, elements }) => (
                                        <SellerStripeForm onExistingCardsClick={(e) => onCardFormToggle(e, false)} areCardsExists={paymentMethods.length} onChange={({ card }) => setCard(card)} stripe={stripe} elements={elements} />
                                    )}
                                </ElementsConsumer>
                            </Elements>
                        </div> :
                            <div className='subscription-container-card-existing'>
                                <div className='subscription-container-card-existing-header'>
                                    Payment Info
                                    <div className='subscription-container-card-btn-container'>
                                        <button className='subscription-container-card-btn' onClick={(e) => onCardFormToggle(e, true)}><span>+</span> Add New Card <img src={next} /> </button>
                                    </div>
                                </div>
                                {paymentMethods.map(pm =>
                                    <div onClick={() => setSelectedPaymentMethod(pm)}><PaymentCard {...pm.card} isSelected={selectedPaymentMethod.id == pm.id} /></div>
                                )}
                            </div> :
                            <div className='payment-methods-loading'> Loading Payment Methods ...</div>
                        }

                    </div>
                    <div className='subscription-container-invoice-section'>
                        {selectedPlan ?
                            <InvoiceSection
                                planType={selectedPlan.plan.planType.toLowerCase()}
                                planPrice={selectedPlan.plan.price}
                                commission={selectedPlan.plan.commission}
                                referralFee={selectedPlan.plan.referralFee}
                                planName={selectedPlan.plan.planName}
                                features={selectedPlan.features}
                                onChange={({ promo }) => setPromo(promo)}
                                activeTabIndex={0}
                                isSellerLoggedIn={true}
                                selectedCategory={selectedCategory}
                            />
                            : ''}
                    </div>
                </Formsy>
            </div>

            <div className={`seller-subscription-tab${activeIndex != 3 ? ' hidden' : ''}`}>
                <div className='confirmation-container'>
                    <img src={confirmImg} />
                    <div className='confirmation-user'>
                        Thank you
                    </div>
                    <div className='confirmation-separator' />
                    <div className='order-header'>More Customers for your business are on the way.</div>
                </div>
            </div>
        </div>
    </div > : ''
}

export default SubscriptionContainer;